import { useState } from "react";
import SelectBox from "../../../utils/components/SelectBox";
import Modal from "../../../utils/components/Modal";
import API from "../../../utils/API";
import { useNavigate } from "react-router";
import { auth } from "../../../App/routes";
import toastr from "toastr";

const WorkflowForwardModal = ({
  taskId,
  workflow,
  users,
  show,
  hideModal,
  translate,
  handleSaveForm = null,
  isSendingFromParent,
  isSendingForm,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSending, setIsSending] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (selectedStatus === null) {
      toastr.error(translate("fill_all_fields"));
      return;
    }

    const payload = {
      task_id: taskId,
      status: selectedStatus ? selectedStatus.label : "",
      step_workers: workflow.statuses[selectedStatus.value].next_steps
        ?.filter((step) => step.need_user)
        ?.map((step) => ({
          step_name: step.step_name,
          users: selectedUsers[step.step_name].map((user) => user.value),
        })),
    };

    setIsSending(true);

    if (handleSaveForm) handleSaveForm(payload, "workflow-forward");
    else {
      setIsSending(true);
      API.postData("workflow/forward", payload)
        .then(({ data: res }) => {
          toastr.success(res.message);
          navigate(auth.tasks.link);
          hideModal("send");
        })
        .catch(() => {
          setIsSending(false);
        });
    }
  };

  return (
    <Modal
      title={`${translate("tasks.workflow_task_submit")} - ${workflow.name}`}
      positiveButtonHandler={handleSubmit}
      positiveButtonNode={translate("send")}
      negativeButtonNode={translate("cancel")}
      modalSize="lg"
      show={show}
      setShow={() => hideModal()}
      disableButtons={isSendingForm || isSendingFromParent || isSending}
    >
      <p className="text-center fw-bold mt-3 mb-2">
        {translate("tasks.active_step")} : {workflow.active_step_name}
      </p>

      <div className="row">
        <p className="mb-2">{translate("tasks.select_status")}</p>
        {workflow.statuses && (
          <SelectBox
            label={translate("please_select")}
            options={workflow.statuses?.map(({ status }, index) => ({
              value: index,
              label: status,
            }))}
            value={selectedStatus && selectedStatus}
            onChange={(value) => setSelectedStatus(value)}
          />
        )}
      </div>

      {selectedStatus &&
        workflow.statuses[selectedStatus.value].next_steps.map(
          ({ step_name, need_user }, index) => (
            <div className="row" key={index}>
              {selectedStatus && need_user && (
                <>
                  <p className="text-center fw-bold mt-5 mb-2">
                    {translate("tasks.step_name")}: {step_name}
                  </p>
                  <p className="mb-2">{translate("tasks.select_users")}</p>
                  {users && (
                    <SelectBox
                      label={translate("please_select")}
                      options={users.map(({ value, label }) => ({
                        value,
                        label,
                      }))}
                      isMulti
                      value={
                        selectedUsers[step_name] && selectedUsers[step_name]
                      }
                      onChange={(data) =>
                        setSelectedUsers({
                          ...selectedUsers,
                          [step_name]: data,
                        })
                      }
                    />
                  )}
                </>
              )}
            </div>
          )
        )}
    </Modal>
  );
};

export default WorkflowForwardModal;
